import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzPupWt } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PUP_WT: Record<
  Exclude<PageIdWoofzPupWt, PageIdWoofzPupWt.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzPupWt.DOG_AGE_PUP_WT]: {
    id: PageIdWoofzPupWt.DOG_AGE_PUP_WT,
    hasHeader: true,
  },
  [PageIdWoofzPupWt.DOG_OWNER_PUP_WT]: {
    id: PageIdWoofzPupWt.DOG_OWNER_PUP_WT,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupWt.TRAINING_COMMANDS_PUP_WT]: {
    id: PageIdWoofzPupWt.TRAINING_COMMANDS_PUP_WT,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupWt.URGE_PAGE_PUP_WT]: {
    id: PageIdWoofzPupWt.URGE_PAGE_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.URGE,
  },
  [PageIdWoofzPupWt.DOG_BREED_PUP_WT]: {
    id: PageIdWoofzPupWt.DOG_BREED_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupWt.FACING_CHALLENGES_PUP_WT]: {
    id: PageIdWoofzPupWt.FACING_CHALLENGES_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupWt.FACING_CHALLENGES_2_PUP_WT]: {
    id: PageIdWoofzPupWt.FACING_CHALLENGES_2_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupWt.BEHAVIOR_FREQUENCY_PUP_WT]: {
    id: PageIdWoofzPupWt.BEHAVIOR_FREQUENCY_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupWt.URGE_PROGRAM_PUP_WT]: {
    id: PageIdWoofzPupWt.URGE_PROGRAM_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupWt.BEHAVIOR_FEELINGS_PUP_WT]: {
    id: PageIdWoofzPupWt.BEHAVIOR_FEELINGS_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupWt.FIX_BEHAVIOR_PUP_WT]: {
    id: PageIdWoofzPupWt.FIX_BEHAVIOR_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupWt.URGE_PAGE_4_PUP_WT]: {
    id: PageIdWoofzPupWt.URGE_PAGE_4_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupWt.COMMANDS_PUP_WT]: {
    id: PageIdWoofzPupWt.COMMANDS_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupWt.PARENT_GOAL_PUP_WT]: {
    id: PageIdWoofzPupWt.PARENT_GOAL_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupWt.TRAINING_PLACE_PUP_WT]: {
    id: PageIdWoofzPupWt.TRAINING_PLACE_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupWt.TRAINING_FREQUENCY_PUP_WT]: {
    id: PageIdWoofzPupWt.TRAINING_FREQUENCY_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPupWt.URGE_PAGE_5_PUP_WT]: {
    id: PageIdWoofzPupWt.URGE_PAGE_5_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.URGE,
  },
  [PageIdWoofzPupWt.PREPARE_FLOW_PUP_WT]: {
    id: PageIdWoofzPupWt.PREPARE_FLOW_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupWt.EMAIL_PUP_WT]: {
    id: PageIdWoofzPupWt.EMAIL_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupWt.NEWSLETTER_URGE_PUP_WT]: {
    id: PageIdWoofzPupWt.NEWSLETTER_URGE_PUP_WT,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPupWt.LAST_CHANCE_OFFER_PUP_WT]: {
    id: PageIdWoofzPupWt.LAST_CHANCE_OFFER_PUP_WT,
  },
  [PageIdWoofzPupWt.SUBSCRIPTIONS_PUP_WT]: {
    id: PageIdWoofzPupWt.SUBSCRIPTIONS_PUP_WT,
  },
  [PageIdWoofzPupWt.CHAT_UPSELL_PUP_WT]: {
    id: PageIdWoofzPupWt.CHAT_UPSELL_PUP_WT,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPupWt.UPSELL_PUP_WT]: {
    id: PageIdWoofzPupWt.UPSELL_PUP_WT,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPupWt.UPSELL_FEEDING_GUIDE_PUP_WT]: {
    id: PageIdWoofzPupWt.UPSELL_FEEDING_GUIDE_PUP_WT,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPupWt.UPSELL_EMOTIONAL_SUPPORT_PUP_WT]: {
    id: PageIdWoofzPupWt.UPSELL_EMOTIONAL_SUPPORT_PUP_WT,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPupWt.DOWNLOAD_PUP_WT]: {
    id: PageIdWoofzPupWt.DOWNLOAD_PUP_WT,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
